import axios from "axios";
import { getClientId } from "@/lib/clientId";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "3cai_auth_token";

export const getAuthToken = () => {
  try {
    return localStorage.getItem(TOKEN_KEY);
  } catch {
    return null;
  }
};

export const setAuthToken = (t) => {
  try {
    if (t) localStorage.setItem(TOKEN_KEY, t);
    else localStorage.removeItem(TOKEN_KEY);
  } catch {
    // no-op
  }
};

export const api = axios.create({
  baseURL: API,
  timeout: 120000,
});

// attach client id + bearer token on every request
api.interceptors.request.use((cfg) => {
  cfg.headers = cfg.headers || {};
  cfg.headers["X-Client-Id"] = getClientId();
  const t = getAuthToken();
  if (t) cfg.headers["Authorization"] = `Bearer ${t}`;
  return cfg;
});

// mark "first AI module ran" for onboarding when any analyze/generate endpoint
// returns a successful response
api.interceptors.response.use((res) => {
  try {
    const url = res?.config?.url || "";
    if (/\/(analyze|generate)(\b|$)/.test(url) && res.status >= 200 && res.status < 300) {
      localStorage.setItem("threec_tour_ai_ran", "1");
    }
  } catch (_e) {}
  return res;
});
